import { Button, Col, Form, InputGroup, Modal, Row, Table} from "react-bootstrap";
import getDateForInputFromMysqlDate from "../../utils/utils";
import PickWorkerSelect from "./PickWorkerSelect";
import React, {useState} from "react";
import useAlert from "../../components/CustomAlert";
import findColorForUser from "./CalendarUtils";
import {useAuth} from "../../providers/authprovider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {useData} from "./Calendar";
import CUSTOM_EVENT_TYPE from "./CustomEventType";


function isValid({value, date_from, date_to, type}){
    if(date_from === undefined || (typeof date_from === "string" && date_from.length<=0))
        return {valid:false, error:"Nie podano daty rozpoczęcia wydarzenia."}

    if(date_to === undefined || (typeof date_to === "string" && date_to.length<=0))
        return {valid:false, error:"Nie podano daty zakończenia wydarzenia."}


    if(new Date(date_to).getTime() < new Date(date_from).getTime())
        return {valid:false, error:"Błędnie wprowadzona data trwania wydarzenia."}

    if(type !== CUSTOM_EVENT_TYPE.VACATION && (value === undefined || value.trim().length<=0))
        return {valid:false, error:"Proszę wprowadzić treśc wydarzenia."}

    return {valid:true};
}

export default function AddEditNoteModal(props){

    const {workers, teams, onSave, onHide} = props;
    const {handleDeleteEvent} = useData();
    const {calendar: {addCustomEvent, remove}, user} = useAuth();
    const {alert, showAlert, hideAlert} = useAlert();
    const [fieldErrors, setFieldErrors] = useState({});
    const [formData, setFormData] = useState(()=>{
        if(props.event === undefined){
            return {users:[], value:"", date_from:new Date(), date_to:new Date(), type: props.eventType}
        }
        const users = props.event.users.map(u=>({...u, active: workers.find(w=>w.id === u.id)?.active}));
        return {...props.event, users}
    })
    const title = getTitle(formData.type);
    const headerClass = `customEventModalHeader ${formData.type}`;
    const isVacation = formData.type === CUSTOM_EVENT_TYPE.VACATION;

    const handlePickWorker = (workerId)=>{
        const user = workers.find(w=>w.id === workerId);
        const worker = formData.users.find(u=>u.id === workerId);

        if(user === undefined)
            return;

        if(worker === undefined){
            setFormData({...formData, users: [...formData.users, {id:user.id, name:user.name, tel:user.tel, position:user.position, active:user.active}]})
            setFieldErrors({...fieldErrors, users: undefined});
        }
    }

    const handleDeleteWorker = (workerId)=>{
        setFormData({...formData, users: [...formData.users.filter(u=>u.id !== workerId)]})
    }

    const handleSave = ()=>{
        hideAlert();
        setFieldErrors({});

        if(!isVacation && (formData.value === undefined || formData.value.trim().length<=0)){
            setFieldErrors({value:getRequiredValueError(formData.type)});
            return;
        }

        if(isVacation && formData.users.length<=0){
            setFieldErrors({users:"Pracownik jest wymagany."});
            return;
        }

        const validate = isValid(formData);

        if(!validate.valid)
            return showAlert(validate.error);

        addCustomEvent(formData, ({success, error, content})=>{

            if(success === false)
                return showAlert(error);

            onSave(content)
            onHide()
        })
    }

    const handleDelete = ()=>{
        if(!window.confirm("Potwierdź usunięcie notatki z terminarza"))
            return;

        remove(props.event.id, ({success, error, content})=>{

            if(!success)
                return showAlert(error)


            handleDeleteEvent(content);
            onHide();
        }, true)
    }

    const handleDataChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if(fieldErrors[e.target.name] !== undefined)
            setFieldErrors({...fieldErrors, [e.target.name]: undefined});
    };
    const isOwner = props.event?.user_id === user.id;


    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

                    <Modal.Header closeButton className={headerClass}>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        { alert() }
                        <Row>
                            <Col>
                                <InputGroup className="mb-3" >
                                    <InputGroup.Text id="team_select">od kiedy</InputGroup.Text>
                                    <Form.Control  defaultValue={getDateForInputFromMysqlDate(formData.date_from)}  type="date" name={"date_from"} placeholder="data od"
                                                   onChange={handleDataChange}/>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup className="mb-3" >
                                    <InputGroup.Text id="team_select">do kiedy</InputGroup.Text>
                                    <Form.Control  value={getDateForInputFromMysqlDate(formData.date_to)}  type="date" name={"date_to"} placeholder="data do"
                                                   onChange={handleDataChange}/>
                                </InputGroup>
                            </Col>
                        </Row>
                        <Form.Control
                            className={"mt-2 mb-2"}
                            value={formData.value}
                            onChange={handleDataChange}
                            name={"value"}
                            type="text"
                            as={"textarea"}
                            rows={isVacation ? 2 : 5}
                            isInvalid={fieldErrors.value !== undefined}
                            placeholder="wprowadź treść "
                        />
                        <Form.Control.Feedback type="invalid">
                            {fieldErrors.value}
                        </Form.Control.Feedback>

                        <Table size={"sm"}  bordered hover>
                            <thead>
                            <tr>
                                <th></th>
                                <th>Imię i nazwisko</th>
                                <th>Numer tel</th>
                                <th>Stanowisko</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                formData.users.map(user=>
                                    <UserRow key={user.id} user={user} teams={teams} onDelete={handleDeleteWorker} />
                                )
                            }
                            </tbody>
                        </Table>
                        <Row>
                            <Col lg={6}></Col>
                            <Col lg={6}>
                                <PickWorkerSelect workers={workers.filter(worker => worker.active)} withButton={false} onPick={handlePickWorker} />
                                <div className={"invalid-feedback d-block"}>
                                    {fieldErrors.users}
                                </div>
                            </Col>
                        </Row>

                    </Modal.Body>
                    <Modal.Footer className={"justify-content-between"}>
                        {
                            (props.event !== undefined && (user.isAdmin || isOwner)) && <Button  variant={"outline-danger"} onClick={handleDelete} title={"Usuń"}><FontAwesomeIcon icon={faTrash} /> Usuń</Button>
                        }
                        <Button  onClick={handleSave} >Zapisz</Button>

                    </Modal.Footer>

        </Modal>
    )
}

function UserRow({user, teams, onDelete}){

    const userColor = findColorForUser(user.id, teams);

    const handleDeletePerson = (id)=>{
        onDelete(id);
    }

    return (
        <tr className={user.active == false ? "worker-inactive" : ""}>
            <td><div className={"userColor"} style={{backgroundColor:userColor}}></div></td>
            <td>{user.name}</td>
            <td>{user.tel}</td>
            <td>{user.position}</td>
            <td>
                <span
                    className={"fs-5 close-btn"}
                    onClick={() => {handleDeletePerson(user.id)}}
                    aria-hidden={"true"}>
                                    &times;
                                </span>
            </td>
        </tr>
    )
}

function getTitle(type){
    if(type === CUSTOM_EVENT_TYPE.NOTE)
        return "Notatka";

    if(type === CUSTOM_EVENT_TYPE.VACATION)
        return "Urlop";
}

function getRequiredValueError(type){
    if(type === CUSTOM_EVENT_TYPE.NOTE)
        return "Treść notatki jest wymagana.";

    if(type === CUSTOM_EVENT_TYPE.VACATION)
        return "Treść urlopu jest wymagana.";
}
